import React from 'react';

export const lazyWithRetries: typeof React.lazy = importer => {
  const retryImport = async () => {
    try {
      return await importer();
    } catch (error: any) {
      for (let i = 0; i < 5; i++) {
        await new Promise(resolve => setTimeout(resolve, 1000 * 2 ** i));
        const url = new URL(
          error.message
            .replace('Failed to fetch dynamically imported module: ', '')
            .trim(),
        );
        url.searchParams.set('t', `${+new Date()}`);

        try {
          return await import(url.href);
        } catch (e) {
          console.log('retrying import');
        }
      }
      throw error;
    }
  };
  return React.lazy(retryImport);
};
